document.addEventListener('DOMContentLoaded', () => {
  let cartReady = false

  if (!customElements.get('gift-order-checkbox')) {
    customElements.define('gift-order-checkbox', class GiftOrderCheckbox extends HTMLElement {
      constructor() {
        super()

        this.computeProductInCart()

        const cart = JSON.parse(this.querySelector('#cart-json').innerHTML)

        this.querySelector('#gift-box-checkbox').addEventListener('click', event => {
          if (!cart.note)
            document.querySelector('gift-order-panel').classList.add('is-open')
          else {
            CartJS.setNote('')
            this.querySelector('#gift-box-checkbox').classList.add('free-gift-loading')

            this.resetGiftCheck()
          }
        })

        this.querySelectorAll(['#tick-text']).forEach(item => item.addEventListener('click', () => {
          document.querySelector('gift-order-panel').classList.add('is-open')
        }))
      }

      resetGiftCheck() {
        document.querySelector('gift-order-checkbox #order-save span').innerHTML = "Save"
        document.querySelector('gift-order-checkbox #tick-text').innerHTML = this.getAttribute('data-text')
        document.querySelector('gift-order-checkbox').classList.remove('activegift')
        // document.querySelector('#order-save').classList.add('disabled')
        $(document).on('cart.requestComplete', this.doUpdate)
      }

      productId = 0
      variantId = 0
      giftBoxInCart = false

      doUpdate() {
        $(document).off('cart.requestComplete', this.doUpdate)
      }

      computeProductInCart() {
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        const cart = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.productId) {
          for (const item of cart.items) {
            if (item.product_id === this.productId) {
              this.giftBoxInCart = true
            }
          }
        } else {
          this.giftBoxInCart = !!cart.note
        }

        if (this.giftBoxInCart) {
          this.classList.add('activegift')
        }
      }
    })
  }

  if (!customElements.get('gift-order-panel')) {
    customElements.define('gift-order-panel', class GiftOrderPanel extends HTMLElement {
      constructor() {
        super()
        const input = this.querySelector('textarea')
        const maxLength = 200

        this.querySelector('.giftnote-remaining-text span').innerHTML = maxLength - String(input.value).length
        input.addEventListener('keydown', (e) => {
          this.querySelector('.giftnote-remaining-text span').innerHTML = maxLength - String(input.value).length
        })

        setTimeout(() => {
          this.style.display = "flex"
        }, 500);

        const cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.computeProductInCart(cartJson)

        this.querySelectorAll(['.mini-cart-giftnote__top--icon', '.btn--giftnote--cancel']).forEach(item => item.addEventListener('click', () => {
          this.classList.remove('is-open')
        }))

        this.defaultText = document.querySelector('#order-save span').innerHTML

        document.querySelector('#gift-order').addEventListener('keydown', () => {
          if (document.querySelector('#gift-order').value)
            document.querySelector('#order-save').classList.remove('disabled')
          else
            document.querySelector('#order-save').classList.add('disabled')
        })

        this.querySelector('#order-save').addEventListener('click', (event) => {
          let target = ''
          if (event.target.id === 'add-gift-box-product') {
            target = event.target
          } else {
            target= event.target.closest('#order-save')
          }

          if (target.classList.contains('disabled')) {
            return
          }

          CartJS.setNote(this.querySelector('#gift-order').value)
          target.classList.add('free-gift-loading')

          $(document).on('cart.requestComplete', this.updateStatus.bind(this))
        })
      }

      updateStatus() {
        this.classList.remove('is-open')
        document.querySelector('#order-save span').innerHTML = "Update"
        this.querySelector('#order-save').classList.remove('free-gift-loading')

        $(document).off('cart.requestComplete', this.updateStatus)
      }

      productId = 0
      defaultText = ''

      computeProductInCart(cart) {
        if (cart.note) {
          this.classList.add('activegift')
        }

        if (cart.note) {
          document.querySelector('#gift-order').value = cart.note || ''
          document.querySelector('#order-save').classList.remove('disabled')
          this.querySelector('.giftnote-remaining-text span').innerHTML = 200 - cart.note.length
        } else {
          document.querySelector('#gift-order').value = ''
        }

        const rate = Number(window.Shopify.currency.rate)
        const giftBoxAmount = Number(this.getAttribute('data-free-amount')) * rate

        if (cart.note) {
          document.querySelector('#order-save span').innerHTML = this.giftBoxInCart && cart.note ? "Update" : 'Save'
        }
      }
    })
  }


})
